/**
 * Validates and formats salary input.
 * Only allows numbers with up to 2 decimal places.
 * Accepts both comma and dot as decimal separator (normalizes to dot).
 */
export const formatSalaryInput = (value: string): string => {
	// Replace comma with dot for decimal
	let normalized = value.replace(',', '.');

	// Remove all non-numeric chars except dot
	normalized = normalized.replace(/[^\d.]/g, '');

	// Only allow one decimal point
	const parts = normalized.split('.');
	if (parts.length > 2) {
		normalized = parts[0] + '.' + parts.slice(1).join('');
	}

	// Limit to 2 decimal places
	if (parts.length === 2 && parts[1].length > 2) {
		normalized = parts[0] + '.' + parts[1].slice(0, 2);
	}

	return normalized;
};

/**
 * Validates if a string is a valid salary value.
 */
export const isValidSalaryInput = (value: string): boolean => {
	if (value === '') return true; // Empty is valid (will be handled as null)
	const pattern = /^\d+(\.\d{0,2})?$/;
	return pattern.test(value);
};
